import validator from "validator";
import { parseStringValue } from "../parse-string-value.js";
const { isUUID } = validator;
export function uuidField(opts) {
    return (value) => {
        const res = parseStringValue(value, opts);
        if (!res.isValid || !res.value)
            return res;
        if (!isUUID(res.value)) {
            return {
                isValid: false,
                error: opts.message,
            };
        }
        return {
            isValid: true,
            value: res.value,
        };
    };
}
